'use client'
import { useLang } from '../../context/LangContext'
import { t, productStorage } from '../../lib/translations'
import ProductLanding from '../../components/ProductLanding'
import Icon from '../../components/Icon'

const featureIcons = ['transfer', 'layers', 'shield', 'globe', 'adjustments', 'apps', 'refresh', 'currency-dollar'] as const

export default function StoragePage() {
  const lang = useLang()
  const features = productStorage.features.map((f, i) => ({
    title: t(lang, f.title),
    description: t(lang, f.description),
    icon: <Icon name={featureIcons[i]} className="w-6 h-6" strokeWidth={1.5} />,
  }))
  const benefits = productStorage.benefits.map((b) => ({ title: t(lang, b.title), desc: t(lang, b.desc) }))

  return (
    <ProductLanding
      id="storage"
      title={t(lang, productStorage.title)}
      subtitle={t(lang, productStorage.subtitle)}
      description={t(lang, productStorage.description)}
      heroBg="bg-gradient-to-b from-[#4f46e5]/5 via-transparent to-transparent"
      heroGlow="bg-[#7c3aed]/10"
      features={features}
      benefits={benefits}
    />
  )
}
